import React from 'react'
import Create from '../crud/create'
import fields from './fields'

const CreateCategory = (props) => {
  let redirectPath
  if (props.routes.find(route => route.path === 'events')) {
    redirectPath = '/events/categories'
  } else {
    redirectPath = '/ecommerce/categories'
  }
  return (
    <Create
      title='Create Category'
      fields={fields}
      apiPath='admin/categories'
      successRedirectPath={resource => `/${redirectPath}/${resource.id}/edit`}
    />
  )
}

export default CreateCategory
